// bd-yj2sq / bd-deepcontext-b4zw — debounce the job search term (300ms, mirroring
// PromptManager). Extracted from ScheduledJobs.tsx.
import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
